const permissions = {
  // page-level access permissions
  usersPage: 'permission_usersPage',
  homePage: 'permission_homePage'
};

export default permissions;
